import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, Renderer2, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { NumberSeparatorPipe } from 'src/app/core/pipes/number.separator.pipe';
import { DialogService } from 'src/app/core/services/dialog.service';
import { MobileNumbersService } from 'src/app/core/services/mobile-numbers.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { ApiNotificationService } from '../../../core/services/api-notification.service';
import { DialogStatus } from '../../../core/services/dialog.service';
import { FileService } from '../../../core/services/file.service';
import { BaseMobilesAnalysisComponent } from './base/base-mobiles-analysis.component';

@Component({
    selector: 'mobile-numbers-widget',
    templateUrl: './mobiles-analysis-widget.component.html',
    styleUrls: ['./mobiles-analysis-widget.component.scss'],
    standalone: false
})
export class MobileAnalysisWidgetComponent
  extends BaseMobilesAnalysisComponent
  implements OnInit
{
  #dialogService = inject(DialogService);
  @Input('title') input_title: string;

  @Input('form') input_form: FormGroup;
  @Input('controlName') input_formControlName: string;
  @Input('groupName') input_formGroupName: string;

  @Input('download') input_download: boolean = true;
  @Input('fileSelector') input_fileSelector: boolean = true;
  @Input('eraser') input_eraser: boolean = true;
  @Input('showWrongTexts') input_showWrongTexts: boolean = true;

  @Input('correctRows') input_correctRows: number = 5;
  @Input('wrongRows') input_wrongRows: number = 5;
  @Input('responsiveClass') input_responsiveClass: string = 'md:tw-w-1/2';

  @Input('importantHelp') input_importantHelp: boolean = false;
  description: any;

  isShowAlertDetailsInManualMode: boolean = false;
  isShowAlertDetailsInUploadMode: boolean = true;
  isShowAlertDetailsInClipboardMode: boolean = false;
  isNeedUserConfirmation: boolean = false;

  constructor(
    protected apiNotificationService: ApiNotificationService,
    protected mobileNumbersService: MobileNumbersService,
    protected sanitizer: DomSanitizer,
    protected dialogService: DialogService,
    protected translate: TranslateService,
    protected UtilityService: UtilityService,
    protected fileService: FileService,
    protected numberSeparatorPipe: NumberSeparatorPipe,
    protected http: HttpClient,
    protected renderer: Renderer2
  ) {
    super(
      mobileNumbersService,
      sanitizer,
      dialogService,
      translate,
      UtilityService,
      fileService,
      numberSeparatorPipe,
      http,
      apiNotificationService,
      renderer
    );
  }
  ngOnInit() {
    if (this.input_formGroupName)
      this.input_form = this.input_form.controls[
        this.input_formGroupName
      ] as FormGroup;
  }

  onChangeAlertDetailsInManualMode(event) {
    const timeOut = setTimeout(() => {
      this.isShowAlertDetailsInManualMode = event.hasAttribute('open');
      clearTimeout(timeOut);
    }, 20);
  }
  onChangeAlertDetailsInUploadMode(event) {
    const timeOut = setTimeout(() => {
      this.isShowAlertDetailsInUploadMode = event.hasAttribute('open');
      clearTimeout(timeOut);
    }, 20);
  }
  onChangeAlertDetailsInClipboardMode(event) {
    const timeOut = setTimeout(() => {
      this.isShowAlertDetailsInClipboardMode = event.hasAttribute('open');
      clearTimeout(timeOut);
    }, 20);
  }

  changeIsNeedUserConfirmation(isNeedUserConfirmation) {
    this.output_isNeedUserConfirmation.emit(isNeedUserConfirmation.checked);
  }

  showErrorDialog(event: any) {
    this.#dialogService.openDialog({
      title: 'common.error',
      message: event?.errorMessage,
      status: DialogStatus.error,
    });
  }
}
